<script>
import SectionCard from '../SectionCard.vue';

export default {
  name: 'AssignedAgentsSection',
  components: { SectionCard },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <SectionCard
    section-id="agents"
    :title="$t('REAL_ESTATE.ASSIGNED_AGENTS.TITLE')"
  >
    <template #action>
      <woot-button
        variant="clear"
        size="small"
        icon="edit"
        @click="$emit('edit')"
      >
        {{ $t('REAL_ESTATE.ASSIGNED_AGENTS.EDIT_BUTTON') }}
      </woot-button>
    </template>

    <p v-if="!project.agents.length" class="text-sm text-slate-400">
      {{ $t('REAL_ESTATE.ASSIGNED_AGENTS.EMPTY') }}
    </p>
    <div v-else class="flex flex-wrap gap-2">
      <span
        v-for="agent in project.agents"
        :key="agent.agent_id"
        class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-200"
      >
        {{ agent.name }}
      </span>
    </div>
  </SectionCard>
</template>
